<template>
	<div class="scanner">
    <video id="camera" autoplay>You need a camera in order to use this app.</video>
    <div id="snapshotLimitOverlay"></div>
    <canvas id="snapshot"></canvas>
    </div>
</template>
<style type="text/css" scoped>
  #camera {
    position: fixed;
    top: 50%;
    left: 50%;

    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;

    z-index: -100;

    transform: translateX(-50%) translateY(-50%) rotateY(180deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotateY(180deg);
    -moz-transform: translateX(-50%) translateY(-50%) rotateY(180deg);
  }

  #snapshotLimitOverlay {
    position: absolute;
    top: 50%;
    left: 50%;

    width: 70vmin;
    height: 70vmin;

    transform: translateX(-50%) translateY(-50%);

    text-align: center;
}

#snapshotLimitOverlay:after {
    content:'';

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.4);
}

#snapshot {
    display: none;
}
</style>
<script>
export default {
  name: 'scanner',
      mounted: function(){
      // init QRCode Web Worker
      var self = this;

      this.video = document.getElementById('camera');
      this.snapshotCanvas = document.getElementById('snapshot');
      this.snapshotContext = this.snapshotCanvas.getContext('2d');
      this.overlay = document.getElementById('snapshotLimitOverlay');
      this.qrcodeWorker = new Worker("static/js/qrcode_worker.js");
      this.qrcodeWorker.postMessage({cmd: 'init'});
      this.qrcodeWorker.addEventListener('message', this.showResult);
      this.initVideoStream();

      window.addEventListener("optimizedResize", this.calculateSquare);
    },
    data: function(){
      return {
        qrcodeWorker: null,
        currentDeviceId: null,
        video: null,
        snapshotSquare: null,
        snapshotContext: null,
        overlay: null,
        person: {}
      }
    },
    methods: {
      showResult: function (e) {
        const resultData = e.data;

        try {
          var data = JSON.parse(resultData);
        }
        catch(err) {
          var data = false;
        }

        // open a dialog with the result if found
        if (resultData !== false && data !== false) {
          this.$emit("scanned", data);
          this.scanCode(true);
        } else {
            // if not found, retry
            this.scanCode();
        }
      },
      initVideoStream: function () {
        var self = this;
          let config = {
              audio: false,
              video: {}
          };
          config.video = this.currentDeviceId ? {deviceId: this.currentDeviceId} : {facingMode: "user"};

          this.stopStream();

          navigator.mediaDevices.getUserMedia(config).then(function (stream) {
              self.video.srcObject = stream;
              self.video.oncanplay = function() {
                self.$emit('ready');
                self.calculateSquare();
                self.scanCode();
              };
          }).catch(function (error) {
              alert(error.name + ": " + error.message);
          });
      },
      stopStream: function() {
          //disableUI();

          if (this.video.srcObject) {
              this.video.srcObject.getTracks()[0].stop();
          }
      },
      calculateSquare: function() {
          // get square of snapshot in the video
          let snapshotSize = this.overlay.offsetWidth;
          this.snapshotSquare = {
              'x': ~~((this.video.videoWidth - snapshotSize)/2),
              'y': ~~((this.video.videoHeight - snapshotSize)/2),
              'size': ~~(snapshotSize)
          };

          this.snapshotCanvas.width = this.snapshotSquare.size;
          this.snapshotCanvas.height = this.snapshotSquare.size;
      },
      scanCode: function(wasSuccess) {
        var self = this;
          setTimeout(function() {
              // capture current snapshot
              self.snapshotContext.drawImage(self.video, 0, 0, self.video.videoWidth, self.video.videoHeight);
              const imageData = self.snapshotContext.getImageData(0, 0, self.video.videoWidth, self.video.videoHeight);

              // scan for QRCode
              self.qrcodeWorker.postMessage({
                  cmd: 'process',
                  width: self.video.videoWidth,
                  height: self.video.videoHeight,
                  imageData: imageData
              });
          }, wasSuccess ? 2000 : 120);
      }
    }
};
</script>
